// Host tokens are handed out when a session is created (or opened through a host link) and
// kept per session code, so the same browser stays the host after a reload.
const STORAGE_KEY = "hostTokens";
const SESSION_KEY = "sessionCode"; // written by the session reducer

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
  } catch {
    return {};
  }
};

const write = (tokens) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
  } catch {
    // storage unavailable (private mode): the host role will not survive a reload
  }
};

export const getHostToken = (code) => (code ? read()[code] || null : null);

export const setHostToken = (code, token) => {
  if (code && token) write({ ...read(), [code]: token });
};

export const clearHostToken = (code) => {
  const tokens = read();
  if (code && code in tokens) {
    delete tokens[code];
    write(tokens);
  }
};

/** The session the app currently shows. */
export const getCurrentSessionCode = () => {
  try {
    return localStorage.getItem(SESSION_KEY) || null;
  } catch {
    return null;
  }
};

/** A link that makes whoever opens it the host of the session (for the host's other devices). */
export const hostLink = (code, token) => `${window.location.origin}/${code}?host=${encodeURIComponent(token)}`;
